<template>
  <div class="drawer-box">
    <el-drawer
    :visible.sync="visible"
    :direction="direction"
    :before-close="handleClose">
    <span slot="title" class="title">{{$t('complaintList.highSearch')}}</span>
    <div class="filter-box">
      <div class="row">
       <span class="label">{{$t('faultFilter.associatedProduct')}}：</span>
       <div class="col">
         <el-select 
          v-model="form.product"
          multiple 
          collapse-tags
          :loading="loading"
          v-scroll="handleScroll" 
          @focus="getProduct"
          :placeholder="$t('faultFilter.choProduct')">
            <el-option
            v-for="(item, idx) in productList"
            :key="'product' + idx"
            :label="item.name"
            :value="item.id">
            </el-option>
        </el-select>
       </div>
      </div>
      <!-- <div class="row" v-if="$route.meta.type === 'temp'">
        <span class="label">创建人：</span>
        <div class="col">
            <el-autocomplete
            v-model="form.name"
            :trigger-on-focus="false"
            name="name"
            value-key="name"
            clearable
            :fetch-suggestions="function (queryString, cb) { return querySearchAsync(queryString, cb, 'name') }"
            placeholder="请输入或选择创建人"
            @select="function (item) { return handleSelect(item, 'name', 'code') }"
            ></el-autocomplete>
        </div>
      </div> -->
      <div class="row">
        <span class="label">{{$t('logsIndex.time')}}：</span>
        <div class="col">
          <el-date-picker
            :style="{ width: '100%' }"
            v-model="form.time"
            value-format="yyyy-MM-dd"
            type="daterange"
            :range-separator="$t('complaintList.get')"
            :start-placeholder="$t('complaintList.startTime')"
            :end-placeholder="$t('complaintList.endTime')">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="btns">
        <el-button class="cancel-btn" @click="handleClose">{{$t('indexTags.cancel')}}</el-button>
        <el-button class="confirm-btn" @click="submit">{{$t('indexTags.sure')}}</el-button>
    </div>
    </el-drawer>
  </div>
</template>

<script>
import { getProductList } from "@/api/goods";
import { getCreaterList } from "@/api/fault"
import { throttle } from "@/util/optimization"
  export default {
    props: {
      visible: { default: false },
      defaultInfo: { 
        default: () => {
            return {};
        }
      },
    },
    computed: {
      listReq() {
        return {
            current: 1,
            size: 10,
            total: 0
        }
      }
    },
    data() {
      return {
        direction: 'rtl',
        timeout:  null,
        api: null,
        form: {
            name: '',
            code: '',
            product: [],
            time: ''
        },
        productList: [],
        nameOptions: [],
        canmore: true,
        loading: false
      }
    },
    created() {
      this.getCreater();
      console.log('this.defaultInfo', this.defaultInfo);
      if(this.defaultInfo) {
        this.clickThrottle();
        this.form.name = this.defaultInfo && this.defaultInfo.createUserObj.name ? this.defaultInfo.createUserObj.name : '';
        this.form.code = this.defaultInfo && this.defaultInfo.createUserObj.code ? this.defaultInfo.createUserObj.code : '';
        this.form.product = this.defaultInfo && this.defaultInfo.productList ? this.defaultInfo.productList.split(",") : [];
        this.form.time = this.defaultInfo && this.defaultInfo.startTime && this.defaultInfo.endTime ? [this.defaultInfo.startTime, this.defaultInfo.endTime] : '';
      }
    },
    methods: {
      // 滚动加载更多
      handleScroll() {
         if(this.canmore) {
            this.clickThrottle();
         }
      },
      // 节流加载
      clickThrottle: throttle(function (event) {
        this.getProduct();
      }, 1000),
      querySearchAsync(queryString, cb, target) {
        var options = [];
        options = this[target + 'Options'];
        console.log(target);
        console.log('options', options);
        var results = queryString ? options.filter(this.createFilter(queryString, target)) : options;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
        cb(results);
        }, 3000 * Math.random());
      },
      createFilter(queryString, target) {
        return (state) => {
          return (state[target].toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item, target, key) {
        this.form[target] = item[target];
        this.form[key] = item[key];
      },
      handleClose() {
        this.$emit("update:visible", false);
      },
      submit() {
        this.$emit('faction', this.form);
        this.handleClose();
      },
      // 获取产品
      async getProduct() {
        this.loading = true;
        const res = await getProductList(this.listReq);
        console.log('product =>', res);
        if(res.data && res.data.code === 200) {
            if(res.data.data.records.length > 0) {
                this.listReq.current++;
                this.productList = this.productList.concat(res.data.data.records);
            } else {
                this.canmore = false;
            }
        }
        this.loading = false;
      },
      async getCreater() {
        const res = await getCreaterList();
        console.log('creater', res.data);
        if(res.data && res.data.code === 200) {
          this.nameOptions = res.data.data;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
/deep/ #el-drawer__title .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
}

.filter-box {
    position: relative;
    padding: 0 51px;
}

.row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.label {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    min-width: 15%;
}

.col {
    flex: 1;
}

.btns {
    position: absolute;
    left: 50%;
    bottom: 93px;
    transform: translate(-50%, 0);
    .cancel-btn {
        color: #50C4CB;
        border-color: #50C4CB;
    }
    .confirm-btn {
        background-color: #50C4CB;
        color: #fff;
    }
}
</style>